// Demonstration facts only; never presented as content from the named upload.
export const SAMPLE_SELECTED_FACTS = [
  { slide_number: 2, text: 'The sinoatrial node is the normal pacemaker of the heart.' },
  { slide_number: 3, text: 'The atrioventricular node delays conduction so the ventricles can fill.' },
  { slide_number: 4, text: 'Purkinje fibers coordinate the spread of the impulse through the ventricles.' },
];
